export const actionTypes = {
  GET_PUBLISHED_PAGE: 'GET_PUBLISHED_PAGE',
  UNPUBLISH_PAGES: 'UNPUBLISH_PAGES',
  STOP_AB_CAMPAIGN: 'STOP_AB_CAMPAIGN',
}

export const mutationTypes = {
  STORE_PUBLISHED_PAGE: 'STORE_PUBLISHED_PAGE',
  ADD_PAGE: 'ADD_PAGE',
  REMOVE_PAGE: 'REMOVE_PAGE',
  REMOVE_ALL_PAGE: 'REMOVE_ALL_PAGE',
  SELECT_ALL_PAGE: 'SELECT_ALL_PAGE',
  SET_IS_LOADING: 'SET_IS_LOADING',
  SET_IS_OPEN_MODAL: 'SET_IS_OPEN_MODAL',
  RESET_UNPUBLISH_DATA: 'RESET_UNPUBLISH_DATA',
  SET_IS_USING_WEB_SOCKET: 'GET_IS_USING_WEB_SOCKET',
  REMOVE_CAMPAIGN_STATUS: 'REMOVE_CAMPAIGN_STATUS',
  CANCEL_CAMPAIGN_STATUS: 'CANCEL_CAMPAIGN_STATUS',
  ADD_CAMPAIGN: 'ADD_CAMPAIGN',
}

export const getterTypes = {
  GET_IS_FETCHED: 'GET_IS_FETCHED',
  GET_PUBLISHED_PAGE: 'GET_PUBLISHED_PAGE',
  GET_UNPUBLISH_LIST: 'GET_UNPUBLISH_LIST',
  GET_IS_LOADING: 'GET_IS_LOADING',
  GET_IS_OPEN_POPUP: 'GET_IS_OPEN_POPUP',
  GET_IS_USING_WEB_SOCKET: 'GET_IS_USING_WEB_SOCKET',
  GET_WAITING_CAMPAIGN_LIST: 'GET_WAITING_CAMPAIGN_LIST',
  SELECTABLE_PAGE: 'SELECTABLE_PAGE',
}
